import { ReportInterface } from '../../../interfaces/report.interface';

export class ClearAwaitingShiftDataReport {
    public static readonly type = '[JobsPlacements] Clear awaiting shift data report';

    constructor(public report: ReportInterface) {}
}
